import type { CaseResultRecord } from '@/lib/blocks/collection/records';

export enum CaseResultWidgetVariant {
  LIST = 'list',
  GRID = 'grid',
  CARDS = 'cards',
}

export interface CaseResultWidgetProps {
  title?: string;
  caseResults: CaseResultRecord[];
}
